export const CHAT_AGENT_ACTION_STATUS = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    CANCEL: 'CANCEL',
    IN_PROGRESS: 'IN_PROGRESS',
};
